<template>
    <v-row>
    <v-col>
    励みになります！！
    <v-btn
    color="brack"
    rounded
    class="footer__col1"
    href="https://www.amazon.jp/hz/wishlist/ls/1Y072CCBYC99Q"
    >
    制作者を応援する<br>
    ほしい物リスト
    </v-btn>
    </v-col>
    <v-col
    class="amber lighten-5 py-1 text-center grey--text"
    cols="12"
    >
    <v-btn
    color="black"
    text
    rounded
    class="footer__col1"
    href="https://twitter.com/MuggyTeaa"
    >
    ©️ついじぇね<br>
    制作者 むぎちゃ / MuggyTea
    </v-btn>
    </v-col>
</v-row>
</template>

<script>
export default {
    name : 'Tipping'
}
</script>

<style scoped>
    .tipping__btn {
        /* display: inline-block; */
        word-break: break-all;
        padding: 2px 8px;
        text-transform: none !important;
        white-space: normal;
        max-width: calc(100% - 30px);
        height: inherit !important;
        }

    .tipping__container > a {
        color: darkblue;
        display: flex;
        }
    .tipping__container {
        display: table;
        padding-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/Tipping.vue